"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationErrorCodeToJSON = exports.ValidationErrorCodeFromJSONTyped = exports.ValidationErrorCodeFromJSON = exports.ValidationErrorCode = void 0;
/**
 * - ERROR_MESSAGE_0: Default error
 * - ERROR_MESSAGE_1: This code may be incorrect. Check it and try again.
 * - ERROR_MESSAGE_2: Enter a code.
 * - ERROR_MESSAGE_3: This code is expired.
 * - ERROR_MESSAGE_4: This promotion is only valid for budgets of {{spend minimum}} or more.
 * - ERROR_MESSAGE_5: This promotion isn't available in your region.
 * - ERROR_MESSAGE_6: You can only use one promotion code at a time and your account has an active promotion. Use this credit before applying a new one.
 * - ERROR_MESSAGE_7: We couldn't apply this code. Check it and try again.
 *
 * @export
 */
exports.ValidationErrorCode = {
    _0: 'ERROR_MESSAGE_0',
    _1: 'ERROR_MESSAGE_1',
    _2: 'ERROR_MESSAGE_2',
    _3: 'ERROR_MESSAGE_3',
    _4: 'ERROR_MESSAGE_4',
    _5: 'ERROR_MESSAGE_5',
    _6: 'ERROR_MESSAGE_6',
    _7: 'ERROR_MESSAGE_7'
};
function ValidationErrorCodeFromJSON(json) {
    return ValidationErrorCodeFromJSONTyped(json, false);
}
exports.ValidationErrorCodeFromJSON = ValidationErrorCodeFromJSON;
function ValidationErrorCodeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.ValidationErrorCodeFromJSONTyped = ValidationErrorCodeFromJSONTyped;
function ValidationErrorCodeToJSON(value) {
    return value;
}
exports.ValidationErrorCodeToJSON = ValidationErrorCodeToJSON;
